document.addEventListener('DOMContentLoaded', function () {
  const submitBtn = document.querySelector('[data-custom-button]');
  const btnText = document.getElementById('custom-btn-text');

  if (!submitBtn || !btnText) return;

  function updateButton() {
    const variantInput = document.querySelector('.product-variant-id');
    if (!variantInput) return;

    const variantId = variantInput.value;

    const data = window.variantDataMap?.[variantId];
    if (!data) return;

    const { preorder, stock } = data;

    const submitBtn = document.querySelector('[data-custom-button]');
    const btnText = document.getElementById('custom-btn-text');

    if (!submitBtn || !btnText) return;

    if (stock <= 0) {
      submitBtn.disabled = true;
      submitBtn.removeAttribute('data-preorder');
      btnText.innerText = 'Sold out';
      return;
    }

    if (preorder) {
      submitBtn.disabled = false;
      submitBtn.setAttribute('data-preorder', 'true');
      btnText.innerText = 'Pre order now';
      return;
    }

    submitBtn.disabled = false;
    submitBtn.removeAttribute('data-preorder');
    btnText.innerText = 'Add to cart';
  }

  updateButton();

  document.addEventListener('change', function () {
    setTimeout(updateButton, 10);
  });
});